/* Elements that handle a click themselves, so a click on one of them is not a click on the
 * row around it. */
const INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'input',
    'label',
    'select',
    'textarea',
    '[role="button"]',
    '[role="link"]',
    '[role="checkbox"]',
    '[role="menuitem"]',
].join(',');

/* Whether a click landed on an interactive element, or inside one. Row-level click handlers
 * use this to leave those clicks to the element that owns them. */
export const isInteractiveClickTarget = (target: EventTarget | null): boolean =>
    target instanceof Element && target.closest(INTERACTIVE_SELECTOR) !== null;
